export const IamStrings = {
  sS: "inAppMessage must be an InAppMessage object",
  eS: "ab-pause-scrolling",
};
